import React                    from 'react';
import { Observe }              from 'rewire-core';
import {
  WithStyle,
  FormView,
}                               from 'rewire-ui';
import classNames               from 'classnames';
import { Theme }                from '@material-ui/core/styles';
import DraggableResizableDialog from '../ui/DraggableResizableDialog';
import duplicateJobsDialogModel from './DuplicateJobsDialogModel';
import { withStyles }           from '../utility/styles';

const styles = (_theme: Theme) => ({
  dateFieldsContainer: {
    display: 'flex',
    '& > div': {
      display: 'flex',
      flex: '1',
      '&:first-child': {
        marginRight: '20px',
      },
    },
  },
});

interface IDuplicateJobsDialogProps {
}

type DuplicateJobsDialogProps = WithStyle<ReturnType<typeof styles>, IDuplicateJobsDialogProps>;

class DuplicateJobsDialog extends React.PureComponent<DuplicateJobsDialogProps> {
  constructor(props: DuplicateJobsDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    duplicateJobsDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    const {classes} = this.props;

    return <Observe render={() => (
      <FormView form={duplicateJobsDialogModel.form} onSubmit={duplicateJobsDialogModel.actionFn('save')}>
        <div className={classNames('content', classes.dateFieldsContainer)}>
          <duplicateJobsDialogModel.form.field.area.Editor />
          <duplicateJobsDialogModel.form.field.group.Editor />
        </div>
        <div className={'content'}>
          <duplicateJobsDialogModel.form.field.occupation.Editor />
        </div>
        <div className={'content'}>
          <duplicateJobsDialogModel.form.field.autoCreateVacancyForAbsenceReasons.Editor />
        </div>
        <div className={'content'}>
          <duplicateJobsDialogModel.form.field.removeOverlappingAssignments.Editor />
        </div>
        <div className={classNames('content', classes.dateFieldsContainer)}>
          <duplicateJobsDialogModel.form.field.effectiveStart.Editor />
          <duplicateJobsDialogModel.form.field.effectiveEnd.Editor />
        </div>
        <div className={'content'}>
          <duplicateJobsDialogModel.form.field.generator.Editor />
        </div>
        <div className={'content'}>
          <duplicateJobsDialogModel.form.field.cycleOffset.Editor />
        </div>
     </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: duplicateJobsDialogModel}} DraggableResizableBoxProps={{minWidth: '336px', minHeight: '430px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IDuplicateJobsDialogProps>(styles, DuplicateJobsDialog);
